import request from '@/utils/request'

//根据车牌查询停车费
export function getStopCarInfo(data) {
    return request({
        url: '/mainPlatform/getStopCarInfo', //mainPlatform yunnanData
        method: 'post',
        data
    })
}
//根据硬件地址查询停车费
export function getStopCarInfoByMac(data) {
    return request({
        url: '/mainPlatform/getStopCarInfoByMac',
        method: 'post',
        data
    })
}
//查询用户车牌绑定关系
export function selectCarAndUserRel(data) {
    return request({
        url: '/handleWx/selectCarAndUserRel',
        method: 'post',
        data
    })
}
//修改用户车牌绑定关系
export function updateCarAndUserRel(data) {
    return request({
        url: '/handleWx/updateCarAndUserRel',
        method: 'post',
        data
    })
}
//添加用户车牌绑定关系
export function addCarAndUserRel(data) {
    return request({
        url: '/handleWx/addCarAndUserRel',
        method: 'post',
        data
    })
}
//根据ID删除绑定关系
export function deleteCarAndUserRel(data) {
    return request({
        url: '/handleWx/deleteCarAndUserRel',
        method: 'post',
        data
    })
}
//根据openId查询缴费记录
export function selectWxPaidrecordList(data) {
    return request({
        url: '/handleWx/selectWxPaidrecordList',
        method: 'post',
        data
    })
}
//根据车牌号查询欠费订单
export function getArrearsList(data) {
    return request({
        url: 'mainPlatform/getArrearsList',
        method: 'post',
        data
    })
}
//根据parkId查询商户
export function getMerchantByParkId(data) {
    return request({
        url: 'handleWx/selectWxParkmerchant',
        method: 'post',
        data
    })
}